import { useNavigate, useParams } from "react-router-dom";
import { t } from "i18next";
import Layout from "./Layout";
import { useEffect, useState } from "react";
import {
  CasinoList,
  CasinoPatformInner,
  CasinoPlatform,
  Crash,
  CrashPlatform,
  CricketPlatform,
  Fishing,
  FishingPatformInner,
  FishingPlatform,
  PlatforAWC,
  Slot,
  SlotPatform,
  Table,
  TablePlatform,
  TablePlatformInner,
} from "./CasinoList";
import { isEmpty, lowerCase, startCase, upperCase } from "lodash";
import { isMobile } from "react-device-detect";
import CasinoWeb from "./CasinoWeb";
import { toast } from "react-toastify";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";

const Casino = () => {
  const navigate = useNavigate();
  const { type, key } = useParams();
  const [data, setData] = useState([]);
  const [tab, setTab] = useState("slot");
  const object = {
    slot: SlotPatform,
    casino: CasinoPatformInner,
    crash: CrashPlatform,
    table: TablePlatformInner,
    fishing: FishingPatformInner,
  };
  const launchCasino = useContextSelector(AuthContext, (ctx) => {
    return ctx.launchCasino;
  });
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  useEffect(() => {
    let obj = {
      slot: Slot,
      casino: CasinoList,
      crash: Crash,
      table: Table,
      fishing: Fishing,
      cricket: CricketPlatform,
    };

    if (!isEmpty(type)) {
      if (!isEmpty(key)) {
        setData(
          obj[type]?.filter((res) => {
            return res?.platform == upperCase(key);
          }),
        );
      } else {
        setData(obj[type]);
      }

      setTab(type);
    }
  }, [type, key]);
  const tabsList = ["slot", "casino", "table", "fishing", "crash"];
  const handleNext = () => {
    const currentIndex = tabsList.indexOf(tab);
    const nextIndex = (currentIndex + 1) % tabsList.length; // loop to start
    navigate(`/casino/${tabsList[nextIndex]}`);
  };

  const handlePrev = () => {
    const currentIndex = tabsList.indexOf(tab);
    const prevIndex = (currentIndex - 1 + tabsList.length) % tabsList.length; // loop to end
    navigate(`/casino/${tabsList[prevIndex]}`);
  };

  const handel = (res) => {
    if (tab == "cricket") {
      if (res?.key == "9 Wickets") {
        if (isMobile) {
          navigate("/inplay-sky");
        } else {
          navigate("/sports-sky");
        }
      } else if (res?.key == "Velkie") {
        navigate("/sports-velki");
      }
    } else {
      if (!isEmpty(user)) {
        if (isEmpty(res?.platFormCode)) {
          toast.error("Comming Soon");
        } else {
          if (!isEmpty(res?.gameid)) {
          } else {
            launchCasino({
              platForm: res?.platFormCode,
              gameType: res?.gameType,
              casinoType: res?.casinoType,
              isLobbyTrue: res?.isLobbyTrue,
            });
          }
        }
      } else {
        navigate("/login");
      }
    }
  };

  return (
    <Layout>
      <div className={isMobile ? "px-2" : ""}>
        <div className="row no-gutters">
          <div className={`col col-12 ${isMobile ? "mobile-padding" : ""} `}>
            <div
              style={{ color: "#ffce01" }}
              className="slot-game-page-card-menu hidden-md-and-up text-center v-card v-sheet theme--light"
            >
              <button
                onClick={handlePrev}
                type="button"
                className="v-icon notranslate mobile-header-navArrow v-icon--link mdi mdi-chevron-left theme--light"
                style={{ "font-size": "36px", color: "#ffce01" }}
              />
              {startCase(tab)}
              <button
                onClick={handleNext}
                type="button"
                className="v-icon notranslate mobile-header-navArrow v-icon--link mdi mdi-chevron-right theme--light"
                style={{ "font-size": "36px", color: "#ffce01" }}
              />
            </div>
            <div
              className="hidden-md-and-up  v-card v-sheet theme--light"
              style={{ "border-radius": "unset" }}
            >
              <div className="mobile-provider-list">
                <div
                  onClick={() => navigate(`/casino/${tab}`)}
                  className={`mobile-provider-card all-provider-div ${
                    isEmpty(key) ? "selected" : ""
                  }`}
                >
                  <span className="all-provider text-center">{t("All")}</span>
                </div>
                {object[type]?.map((res) => {
                  return (
                    <div
                      onClick={() =>
                        navigate(`/casino/${tab}/${lowerCase(res?.key)}`)
                      }
                      className="mobile-provider-card"
                    >
                      <div
                        className="v-image v-responsive provider-card-img theme--light"
                        style={{
                          height: "60px",
                          "max-height": "60px",
                          width: "auto",
                        }}
                      >
                        <div
                          className="v-responsive__sizer"
                          style={{ "padding-bottom": "100%" }}
                        />
                        <div
                          className="v-image__image v-image__image--cover"
                          style={{
                            "background-image": `url(${
                              !isEmpty(key) && upperCase(key) == res?.key
                                ? res?.selected
                                : res?.img
                            })`,
                            "background-position": "center center",
                          }}
                        />
                        <div
                          className="v-responsive__content"
                          style={{ width: "300px" }}
                        />
                      </div>
                      <span className="text-center mobile-vendor-name">
                        {res?.key}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
            {!isMobile && (
              <CasinoWeb
                data={data}
                handel={handel}
                platForm={object[type]}
                key={key}
                tab={tab}
              />
            )}
            {isMobile && (
              <div className="mx-auto gamesCardContainer v-card v-sheet theme--light mb-4">
                <div className="v-image v-responsive align-end hidden-sm-and-down theme--light">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "38.8889%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--cover"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content">
                    <div className="v-card__title white--text font-weight-bold pa-0">
                      <p className="mb-0 ml-3">
                        <span>{startCase(type)} games</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className>
                  <div className="row hidden-md-and-up no-gutters justify-end col-12 py-0">
                    <div className="col-md-6 col-lg-3 col-12 py-0 pr-3">
                      <div className="v-input search_game_text pl-0 theme--light v-text-field v-text-field--single-line v-text-field--solo v-text-field--filled v-text-field--is-booted v-text-field--enclosed v-text-field--rounded v-select v-autocomplete">
                        <div className="v-input__control">
                          <div
                            role="combobox"
                            aria-haspopup="listbox"
                            aria-expanded="false"
                            aria-owns="list-705"
                            className="v-input__slot"
                            style={{
                              "background-color": "rgb(255, 255, 255)",
                              "border-color": "rgb(255, 255, 255)",
                            }}
                          >
                            <div className="v-input__prepend-inner">
                              <i
                                aria-hidden="true"
                                className="v-icon notranslate mdi mdi-magnify theme--light"
                                style={{
                                  color: "rgb(149, 149, 149)",
                                  "caret-color": "rgb(149, 149, 149)",
                                }}
                              />
                            </div>
                            <div className="v-select__slot">
                              <label
                                htmlFor="input-705"
                                className="v-label theme--light"
                                style={{
                                  left: "0px",
                                  right: "auto",
                                  position: "absolute",
                                }}
                              >
                                {t("SearchGames")}
                              </label>
                              <input
                                autoComplete="off"
                                id="input-705"
                                type="text"
                              />
                              <div className="v-input__append-inner">
                                <div />
                              </div>
                              <div className="v-input__append-inner">
                                <div className="v-input__icon v-input__icon--append">
                                  <button
                                    aria-hidden="true"
                                    type="button"
                                    tabIndex={-1}
                                    className="v-icon notranslate v-icon--link mdi mdi-menu-down theme--light"
                                  />
                                </div>
                              </div>
                              <input type="hidden" />
                            </div>
                            <div className="v-menu">{/**/}</div>
                          </div>
                          <div className="v-text-field__details">
                            <div className="v-messages theme--light">
                              <div className="v-messages__wrapper" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    role="list"
                    className="v-list slot-game-card-select px-2 v-sheet theme--light"
                  >
                    {data?.map((res) => {
                      return (
                        <div
                          onClick={() => handel(res)}
                          tabIndex={-1}
                          role="listitem"
                          className="v-list-item theme--light px-0 slot-game-card-item text-center mb-2"
                        >
                          <div className="elevation-0 v-card v-sheet theme--light">
                            <span
                              right
                              className="v-badge v-badge--overlap theme--light"
                            >
                              <div
                                className="v-avatar game_icon_sizing gameButton"
                                style={{
                                  height: "48px",
                                  "min-width": "48px",
                                  width: "48px",
                                }}
                              >
                                <div className="v-image v-responsive theme--light">
                                  <div
                                    className="v-responsive__sizer"
                                    style={{ "padding-bottom": "100%" }}
                                  />
                                  <div
                                    className="v-image__image v-image__image--cover"
                                    style={{
                                      "background-image": `url(${res?.img})`,
                                      "background-position": "center center",
                                    }}
                                  />
                                  <div
                                    className="v-responsive__content"
                                    style={{ width: "450px" }}
                                  />
                                </div>
                                <div className="slot-game-button-container">
                                  <div className="slot-game-button-container-box">
                                    <div className="slot-game-button-box d-flex justify-center">
                                      <button
                                        type="button"
                                        className="slot-game-button v-btn v-btn--icon v-btn--round theme--light v-size--default"
                                      >
                                        <span className="v-btn__content">
                                          <div
                                            className="v-avatar"
                                            style={{
                                              height: "48px",
                                              "min-width": "48px",
                                              width: "48px",
                                            }}
                                          >
                                            <img
                                              src="/assets/images/play_btn.svg"
                                              alt
                                            />
                                          </div>
                                        </span>
                                      </button>
                                      {/**/}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </span>
                          </div>
                          <span className="v-tooltip v-tooltip--bottom"></span>
                          <div
                            aria-haspopup="true"
                            aria-expanded="false"
                            className="v-card__text pt-2 font-weight-bold slot-game-name-box text-center elevation-0"
                          >
                            {res?.name}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Casino;
